export enum Resolvers {
  // Resolvers de tiendas
  STORES = 'storesResolver',

  // Resolvers de vehículos
  ALL_VEHICLES = 'allVehiclesResolver',
  ALL_VEHICLE_BRANDS = 'allVehicleBrandsResolver',
  ALL_VEHICLE_MODELS = 'allVehicleModelsResolver',
  TOP_VEHICLES_YEARS_MODELS = 'topVehiclesYearsModelsResolver',

  // Resolvers de productos
  ALL_PRODUCTS_TOP_BRANDS = 'allProductsTopBrandsResolver',

  // Resolvers de grupos
  ALL_GROUPS_SUBCATEGORIES_DESTACED = 'allGroupsSubcategoriesDestacedsResolver',
  ALL_GROUPS_PRODUCTS_DESTACED = 'allGroupsProductsDestacedsResolver',
}
